<template>
    <v-layout v-if="getPermission('service:create')">
        <v-col class="custom-content-container pt-0" cols="12" md="12" sm="12">
            <div v-if="errors.length" class="iv-custom-field pt-0 width-100">
                <div class="alert fade alert-danger" role="alert" v-bind:class="{ show: errors.length }">
                    <div v-for="(error, i) in errors" :key="i" class="alert-text">
                        {{ error }}
                    </div>
                </div>
            </div>
            <v-tabs v-model="assetTab" background-color="transparent" centered color="cyan" fixed-tabs grow
                class="custom-tab-transparent" hide-slider>
                <template v-for="(tab, index) in tabs">
                    <v-tab class="font-size-16 font-weight-600 px-4"
                        v-if="getPermission(tab.permission + ':create') && tab.status" :key="index"
                        :href="'#tab-' + tab.key">
                        <v-icon color="grey darken-4" left>{{ tab.icon }}</v-icon>
                        {{ tab.title }}
                    </v-tab>
                </template>
            </v-tabs>
            <v-row>
                <v-col cols="12" md="3" sm="3" class="text-center">
                    <template>

                        <v-img :lazy-src="$defaultImage" :src="getProfileImage ? getProfileImage : $defaultImage"
                            max-height="200" max-width="200" height="200px" width="200px"
                            class="custom-grey-border custom-border-radius-50 company-image-logo margin-auto" />

                        <div class="d-flex justify-center">

                            <v-btn class="my-4 custom-bold-button" outlined small v-on:click="selectImage" color="cyan"
                                :loading="imageLoading" :disabled="imageLoading">
                                <template v-if="getProfileImage">Change Image</template>
                                <template v-else>Upload Image</template>
                            </v-btn>

                            <div class="d-none">
                                <v-file-input ref="uploadImage" v-on:change="updateProfileImage" :rules="imageRules"
                                    accept="image/png, image/jpeg, image/jpg"></v-file-input>
                            </div>
                        </div>
                    </template>
                </v-col>
                <v-col cols="7" md="7" sm="8">

                    <v-tabs-items v-model="assetTab">
                        <v-tab-item :value="'tab-overview'">
                            <perfect-scrollbar :options="{ suppressScrollX: true }"
                                class="scroll custom-box-top-inner-shadow service-create-height"
                                style="max-height: 80vh; position: relative">
                                <v-container fluid class="py-0">
                                    <v-card flat class="custom-grey-border remove-border-radius">
                                        <v-card-title class="headline grey lighten-4">
                                            <h3 class="font-weight-700 custom-headline color-custom-blue">
                                                Service Information
                                            </h3>
                                        </v-card-title>
                                        <v-card-text class="p-6 font-size-16">
                                            <v-layout class="pl-1">
                                                <v-row>
                                                    <v-col lg="6" class="py-0">
                                                        <label
                                                            class="font-weight-700 font-size-16 required">Name</label>
                                                        <TextField id="product-name" dense filled placeholder="Name"
                                                            solo flat counter="50" v-model.trim="productCreate.name"
                                                            color="cyan" :maxlength="250" :rules="[
                                                                validateRules.required(productCreate.name, 'Name'),
                                                            ]" />
                                                    </v-col>
                                                    <v-col lg="6" class="py-0">
                                                        <div class="d-flex justify-space-between">
                                                            <label
                                                                class="pr-2 font-weight-700 font-size-16 width-100 required">
                                                                Service Type
                                                            </label>
                                                            <v-icon small @click="ServiceData">mdi-cog</v-icon>
                                                        </div>
                                                        <v-autocomplete :items="serviceList" dense filled color="cyan"
                                                            item-color="cyan" placeholder="Service Type" solo flat
                                                            @change="onServiceTypeChange" item-text="type"
                                                            item-value="type" class="width-100"
                                                            v-model="productCreate.service_type" :rules="[
                                                                validateRules.required(productCreate.service_type, 'Service Type'),
                                                            ]">
                                                            <template v-slot:no-data>
                                                                <v-list-item>
                                                                    <v-list-item-content>
                                                                        <v-list-item-title
                                                                            v-html="'No service(s) Found.'"></v-list-item-title>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </template>
                                                        </v-autocomplete>
                                                    </v-col>
                                                </v-row>
                                            </v-layout>
                                            <v-layout class="pl-1">
                                                <v-row>
                                                    <v-col lg="2" class="py-0">
                                                        <label
                                                            class="pr-2 font-weight-700 font-size-16 width-100">Service
                                                            No.
                                                            Prefix
                                                        </label>
                                                        <v-text-field id="prefix"
                                                            v-model.trim="productCreate.product_prefix" dense filled
                                                            placeholder="Prefix" solo flat color="cyan"
                                                            class="width-100 pb-0"></v-text-field>
                                                    </v-col>
                                                    <v-col lg="4" class="py-0">

                                                        <label
                                                            class="pr-2 font-weight-700 font-size-16 width-100">Service
                                                            No.</label>
                                                        <v-text-field type="number" id="prefix_no"
                                                            v-model.trim="productCreate.product_prefix_no" dense filled
                                                            placeholder="Prefix no" solo flat color="cyan"
                                                            class="width-100 pb-0" :min="0" :max="20"
                                                            v-on:keypress="isNumber($event)"></v-text-field>
                                                    </v-col>
                                                    <v-col lg="6" class="py-0">

                                                        <label
                                                            class="pr-2 font-weight-700 font-size-16 width-100">Preview</label>
                                                        <div class="font-weight-bold font-size-16 mt-2">
                                                            {{ productCreate.product_prefix }}-{{
                                                                productCreate.product_prefix_no
                                                            }}
                                                        </div>
                                                    </v-col>
                                                </v-row>
                                            </v-layout>
                                            <v-layout class="pl-1">
                                                <v-row>
                                                    <v-col lg="6" class="py-0">
                                                        <div class="d-flex justify-space-between">
                                                            <label
                                                                class="pr-2 font-weight-700 font-size-16 width-100">Category
                                                            </label>
                                                            <v-icon @click="CategoryData" small>mdi-cog</v-icon>
                                                        </div>
                                                        <v-autocomplete dense filled color="cyan" item-color="cyan"
                                                            :items="categoryList" placeholder="Category" solo flat
                                                            item-text="text" item-value="text" class="width-100"
                                                            v-model.trim="productCreate.category">
                                                            <template v-slot:no-data>
                                                                <v-list-item>
                                                                    <v-list-item-content>
                                                                        <v-list-item-title
                                                                            v-html="'No Category(s) Found.'"></v-list-item-title>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </template>
                                                        </v-autocomplete>
                                                    </v-col>
                                                    <v-col lg="6" class="py-0">
                                                        <label
                                                            class="pr-2 font-weight-700 font-size-16 width-100 required">Advance
                                                            Day
                                                            Booking
                                                        </label>

                                                        <v-text-field id="booking_advance_days"
                                                            v-model.trim="productCreate.booking_advance_days"
                                                            type="number" dense filled
                                                            placeholder=" Advance Day Booking" solo flat color="cyan"
                                                            @keydown="restrictNegativeInput($event)" suffix="Days"
                                                            class="width-100"
                                                            :rules="[validateRules.required(productCreate.booking_advance_days, 'Booking Advance Days')]"></v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </v-layout>
                                            <v-layout class="pl-1">
                                                <v-row>
                                                    <v-col lg="6" class="py-0">
                                                        <label
                                                            class="pr-2 font-weight-700 font-size-16 width-100">Tags</label>
                                                        <TagAutoComplete type="service" v-model="productCreate.tags" />
                                                    </v-col>
                                                    <v-col lg="6" class="py-0">
                                                        <label
                                                            class="pr-2 font-weight-700 font-size-16 width-100">Specification</label>
                                                        <v-text-field id="specification"
                                                            v-model.trim="productCreate.specification" dense filled
                                                            placeholder="Specification" solo flat color="cyan"
                                                            class="width-100"></v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </v-layout>
                                            <v-layout class="pl-1">
                                                <v-row v-if="false">
                                                    <v-col lg="6" class="py-0">
                                                        <label class="pr-2 font-weight-700 font-size-16 width-100">Off
                                                            Day Service
                                                            Rules</label>
                                                        <v-select :items="offDayServiceRules"
                                                            v-model="productCreate.off_day_service_rules"
                                                            item-text="name" item-value="name" item-color="cyan"
                                                            hide-details dense filled solo flat color="cyan"
                                                            class="line-item-header-text discount-type text-h6 px-0" />

                                                    </v-col>
                                                    <v-col lg="6" class="py-0">
                                                        <label class="pr-2 font-weight-700 font-size-16 width-100">Max
                                                            Performed
                                                            jobs</label>
                                                        <v-text-field v-model="productCreate.daily_service_limit"
                                                            @keydown="restrictNegativeInput($event)" type="number" dense
                                                            filled flat solo color="cyan"
                                                            placeholder="Max Performed jobs" class="ma-0" :rules="[validateRules.lessThan(
                                                                productCreate.daily_service_limit,
                                                                'Max Team',
                                                                100
                                                            ), validateRules.validNumeric(
                                                                productCreate.daily_service_limit,
                                                                'Max Performed Job',
                                                            ),]" />
                                                    </v-col>
                                                </v-row>
                                            </v-layout>
                                            <v-layout class="pl-1"
                                                v-if="!getServiceType(productCreate.service_type)?.is_house_type_visible">
                                                <v-row v-if="productCreate.engineer_required == 1">
                                                    <v-col lg="6" class="py-0">
                                                        <label
                                                            class="pr-2 font-weight-700 font-size-16 width-100 required">Minimum
                                                            Worker</label>
                                                        <v-text-field v-model="productCreate.min_team" type="number"
                                                            dense filled flat solo
                                                            @keydown="restrictNegativeInput($event)"
                                                            @change="validateTeamRange" color="cyan"
                                                            placeholder="Enter Minimum Worker" class="ma-0"
                                                            :rules="[validateRules.lessThan(
                                                                productCreate.min_team,
                                                                'Min Team',
                                                                100
                                                            ), validateRules.validNumeric(
                                                                productCreate.max_team,
                                                                'Minimum Worker',
                                                            ), validateRules.required(productCreate.min_team, 'Max Team')]" />
                                                    </v-col>
                                                    <v-col lg="6" class="py-0">
                                                        <label
                                                            class="pr-2 font-weight-700 font-size-16 width-100 required">Maximum
                                                            Worker</label>
                                                        <v-text-field v-model="productCreate.max_team" type="number"
                                                            dense filled flat solo
                                                            @keydown="restrictNegativeInput($event)"
                                                            @change="validateTeamRange" color="cyan"
                                                            placeholder="Enter Maximum Worker" class="ma-0"
                                                            :rules="[validateRules.validNumeric(
                                                                productCreate.max_team,
                                                                'Maximum Worker',
                                                            ), validateRules.required(productCreate.max_team, 'Max Team')]" />
                                                    </v-col>
                                                </v-row>
                                            </v-layout>
                                            <v-layout class="pl-1">
                                                <v-row>
                                                    <v-col lg="6" class="py-0">
                                                        <label class="pr-2 font-weight-700 font-size-16 width-100">
                                                            Payment Mode
                                                        </label>
                                                        <v-autocomplete :items="paymentType" dense filled color="cyan"
                                                            item-color="cyan" placeholder="Payment Mode" solo flat
                                                            item-text="value" multiple item-value="value" class=" "
                                                            v-model="productCreate.payment_mode">
                                                            <template v-slot:no-data>
                                                                <v-list-item>
                                                                    <v-list-item-content>
                                                                        <v-list-item-title
                                                                            v-html="'Payment Mode.'"></v-list-item-title>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </template>
                                                        </v-autocomplete>
                                                    </v-col>
                                                    <v-col lg="6" class="py-0">
                                                        <label
                                                            class="pr-2 font-weight-700 font-size-16 width-100 required">Zone</label>
                                                        <v-select :menu-props="{ offsetY: true }"
                                                            v-model="productCreate.zone" :items="zoneList" multiple
                                                            chips dense filled solo flat color="cyan"
                                                            :rules="[validateRules.required(productCreate.zone, 'Zone Type')]"
                                                            placeholder="Select Zone" item-text="name"
                                                            item-value="id"></v-select>
                                                    </v-col>
                                                </v-row>
                                            </v-layout>
                                            <v-layout class="pl-1">
                                                <v-row>
                                                    <v-col lg="3" class="py-0">
                                                        <v-switch v-model.trim="productCreate.engineer_required" inset
                                                            :true-value="1" :false-value="0" color="cyan" hide-details
                                                            label="Cleaner Required" class="mt-0"></v-switch>
                                                    </v-col>
                                                    <v-col lg="3" class="py-0">
                                                        <v-switch v-model.trim="productCreate.cancellation_allowed"
                                                            inset :true-value="1" :false-value="0" color="cyan"
                                                            hide-details label="Cancellation Allowed"
                                                            @change="cancelValueUpdated(productCreate.cancellation_allowed)"
                                                            class="mt-0"></v-switch>
                                                    </v-col>

                                                    <v-col lg="3" class="py-0">
                                                        <v-switch v-model.trim="productCreate.is_recurring"
                                                            v-on:change="checkRecurringStatus" inset :true-value="1"
                                                            :false-value="0" color="cyan" hide-details
                                                            label="Recurring Allowed" class="mt-0"></v-switch>
                                                    </v-col>
                                                    <v-col lg="3" class="py-0">
                                                        <v-switch v-model.trim="productCreate.is_service_form"
                                                            v-on:change="checkRecurringStatus" inset :true-value="1"
                                                            :false-value="0" color="cyan" hide-details
                                                            label="Is Service Form Mandatory" class="mt-0"></v-switch>
                                                    </v-col>
                                                </v-row>
                                            </v-layout>
                                        </v-card-text>
                                    </v-card>
                                    <v-card flat class="custom-grey-border remove-border-radius"
                                        v-if="productCreate.cancellation_allowed === 1">
                                        <v-card-title class="headline grey lighten-4">
                                            <h3 class="font-weight-700 custom-headline color-custom-blue">
                                                Cancellation
                                            </h3>
                                            <v-spacer></v-spacer>
                                            <v-btn class="white--text mr-2" depressed color="cyan" tile
                                                v-on:click="addType">
                                                <v-icon left>mdi-plus</v-icon>
                                                <span class="font-size-16 font-weight-600">Add Charges</span>
                                            </v-btn>
                                        </v-card-title>
                                        <v-card-text style="padding-left: 14px !important" class="font-size-16">
                                            <v-row>
                                                <v-col lg="4">
                                                    <label class="required"> Days Without Penalty </label>
                                                    <v-text-field id="no_penalty_cancel_days"
                                                        v-model.trim="productCreate.no_penalty_cancel_days" dense filled
                                                        placeholder="Days Without Penalty" solo flat color="cyan"
                                                        type="number" @keydown="restrictNegativeInput($event)"
                                                        suffix="Days" class="width-100" :rules="[validateRules.lessThan(
                                                            productCreate.no_penalty_cancel_days,
                                                            'No Penalty Cancel Days',
                                                            365
                                                        ), validateRules.required(
                                                            productCreate.no_penalty_cancel_days,
                                                            'Penalty Cancellation Days'
                                                        )]"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row class="py-0" v-if="productCreate?.chargeList?.length > 0">
                                                <v-col md="12" class="py-0">
                                                    <table class="width-100">
                                                        <thead>
                                                            <tr>
                                                                <th class="p-0">Cancellation Charges Within</th>
                                                                <th class="p-0">Charges</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody v-for="(type, index) in productCreate.chargeList"
                                                            :key="index">
                                                            <tr>
                                                                <td class="p-0">
                                                                    <v-text-field v-model="type.charge_duration" dense
                                                                        filled placeholder="Charges Duration" solo flat
                                                                        class="px-1 py-1" hide-details color="cyan"
                                                                        :rules="[
                                                                            validateRules.required(
                                                                                type.charge_duration,
                                                                                'charge duration'
                                                                            ),
                                                                        ]" />
                                                                </td>
                                                                <td width="30%" class="p-0" valign="middle"
                                                                    align="center">
                                                                    <div class="d-flex">
                                                                        <v-text-field hide-details
                                                                            class="line-item-header-text px-0"
                                                                            placeholder="Charges" dense :maxlength="6"
                                                                            filled solo flat v-model="type.charge"
                                                                            color="cyan" :rules="[
                                                                                validateRules.required(
                                                                                    type.charge,
                                                                                    'Charge type'
                                                                                ),
                                                                            ]" />
                                                                        <v-select :items="charge_type_list"
                                                                            v-model="type.charge_type" hide-details
                                                                            item-text="type" item-value="type"
                                                                            item-color="cyan"
                                                                            class="line-item-header-text discount-type text-h6 px-0"
                                                                            placeholder="Type" dense filled solo flat
                                                                            color="cyan" :rules="[
                                                                                validateRules.required(
                                                                                    type.charge_type,
                                                                                    'charge type'
                                                                                ),
                                                                            ]" />
                                                                    </div>
                                                                </td>
                                                                <td class="p-0">
                                                                    <v-tooltip top content-class="custom-top-tooltip">
                                                                        <template v-slot:activator="{ on, attrs }">
                                                                            <v-icon @click="deleteCharges(index)"
                                                                                color="deep-orange" v-bind="attrs"
                                                                                v-on="on">
                                                                                mdi-delete
                                                                            </v-icon>
                                                                        </template>
                                                                        <span>Click here to delete</span>
                                                                    </v-tooltip>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>

                                    <v-card flat class="custom-grey-border remove-border-radius">
                                        <v-card-title class="headline grey lighten-4">
                                            <h3 class="font-weight-700 custom-headline color-custom-blue">
                                                Pricing Information
                                            </h3>
                                            <v-spacer></v-spacer>
                                        </v-card-title>
                                        <v-card-text style="padding-left: 14px !important" class="font-size-16">
                                            <v-col md="12" class="py-0 px-0">
                                                <template v-if="pageLoading">

                                                    <div class="middle-header-background d-flex align-center">
                                                        <p class="mb-0">
                                                            Price Information<br />
                                                            <span>
                                                                <v-icon small>mdi-progress-question</v-icon>
                                                                Specify the unit price, selling cost price
                                                                details for your service</span>
                                                        </p>
                                                    </div>
                                                </template>
                                            </v-col>

                                            <v-row>
                                                <v-col lg="6" class="py-0 ml-3 mt-2"
                                                    v-if="getServiceType(productCreate.service_type)?.is_hours_visible === true">
                                                    <div class="d-flex justify-space-between">
                                                        <label class="pr-2 font-weight-700 font-size-16 width-100">Hours
                                                        </label>
                                                        <!-- <v-icon small @click="hourData">mdi-cog</v-icon> -->
                                                    </div>
                                                    <span class="font-weight-bold font-size-16">
                                                        <v-text-field dense type="number" filled placeholder="Hours"
                                                            solo flat class="width-100" color="cyan"
                                                            v-model.trim="productCreate.hours" :suffix="'Hours'"
                                                            :rules="validateRules.maxLength(productCreate.hours, 'Size', 10)"
                                                            v-on:keypress="(e) => manageLimit(e, productCreate.hours?.length, 10)"></v-text-field>
                                                    </span>
                                                </v-col>
                                            </v-row>
                                            <v-row class="mb-4"
                                                v-if="getServiceType(productCreate.service_type)?.is_house_type_visible">
                                                <v-col cols="12" class="d-flex justify-end mb-3">
                                                    <v-btn color="cyan" class="white--text" @click="addService">
                                                        Add House Type
                                                    </v-btn>
                                                </v-col>
                                                <div style="overflow-x: auto; width: 100%;">
                                                    <table style="min-width: 1000px; border-collapse: collapse;">
                                                        <thead>
                                                            <tr style="background-color: #e5e1e1">
                                                                <th
                                                                    style="text-align: center; font-weight: bold; width: 60px;">
                                                                    S.no
                                                                </th>
                                                                <th
                                                                    style="text-align: center; font-weight: bold; width: 180px;">
                                                                    House Type<v-icon small @click="houseData"
                                                                        class="ml-2">mdi-cog</v-icon></th>
                                                                <th
                                                                    style="text-align: center; font-weight: bold; width: 120px;">
                                                                    Size</th>

                                                                <th
                                                                    style="text-align: center; font-weight: bold; width: 140px;">
                                                                    Duration(s)</th>

                                                                <th
                                                                    style="text-align: center; font-weight: bold; width: 120px;">
                                                                    Price</th>

                                                                <th
                                                                    style="text-align: center; font-weight: bold; width: 140px;">
                                                                    Man Power</th>

                                                                <th
                                                                    style="text-align: center; font-weight: bold; width: 120px;">
                                                                    Action</th>

                                                            </tr>
                                                        </thead>
                                                        <template v-if="productCreate.serviceSelected?.length > 0">
                                                            <tr v-for="(row, index) in productCreate.serviceSelected"
                                                                :key="index" style="border-bottom: 1px solid #ddd;"
                                                                :class="index % 2 != 0 ? 'bg-light' : ''">
                                                                <td align="center" valign="middle"
                                                                    style="padding: 10px">
                                                                    {{ index + 1 }}
                                                                </td>
                                                                <td>
                                                                    <v-autocomplete :items="houseType" dense filled solo
                                                                        flat item-text="value" item-value="value"
                                                                        class="mt-2" placeholder="House Type"
                                                                        v-model="row.house_type" :rules="[
                                                                            validateRules.required(row.house_type, 'house_type'),
                                                                        ]"></v-autocomplete>
                                                                </td>
                                                                <td align="center" valign="middle"
                                                                    style="padding: 5px; font-weight: 500; font-size: 14px">
                                                                    <v-text-field dense filled solo flat
                                                                        placeholder="Size" type="number"
                                                                        @keypress="restrictNonNumericInput($event)"
                                                                        v-model.trim="row.size"
                                                                        style="max-width: 150px;" :suffix="'sqf'"
                                                                        class="mt-2" :rules="[
                                                                            validateRules.required(row.size, 'Size'),
                                                                        ]"></v-text-field>
                                                                </td>
                                                                <td align="center" valign="middle"
                                                                    style="padding: 10px; font-weight: 500; font-size: 14px">
                                                                    <div class="d-flex">
                                                                        <v-text-field dense filled solo flat
                                                                            placeholder="Duration" type="number"
                                                                            v-model.trim="row.hour" class="mt-2"
                                                                            style="width: 70px" :rules="[
                                                                                validateRules.required(row.hour, 'hour'),
                                                                            ]"></v-text-field>

                                                                        <v-autocomplete :items="durationTypes" dense
                                                                            filled solo flat item-text="day_of_week"
                                                                            item-value="day_of_week" class="mt-2"
                                                                            placeholder="Type"
                                                                            v-model="row.duration_type"
                                                                            style="width: 70px"></v-autocomplete>
                                                                    </div>
                                                                </td>
                                                                <td align="center" valign="middle"
                                                                    style="padding: 10px; font-weight: 500; font-size: 14px">
                                                                    <v-text-field dense filled solo flat
                                                                        placeholder="Price"
                                                                        @keypress="restrictNonNumericInput($event)"
                                                                        v-model.trim="row.price"
                                                                        style="max-width: 150px;" :prefix="'$'"
                                                                        class="mt-2" :rules="[
                                                                            validateRules.required(row.price, 'Price'),
                                                                        ]"></v-text-field>
                                                                </td>
                                                                <td align="center" valign="middle"
                                                                    style="padding: 10px; font-weight: 500; font-size: 14px">
                                                                    <v-text-field dense filled solo flat
                                                                        v-if="productCreate.engineer_required == 1"
                                                                        placeholder="Man Power"
                                                                        style="max-width: 150px;" type="number"
                                                                        v-model.trim="row.man_power" class="mt-2"
                                                                        :rules="[
                                                                            validateRules.required(row.man_power, 'Man Power'),
                                                                        ]"></v-text-field>
                                                                    <span style="color:grey" v-else>

                                                                        not required
                                                                    </span>
                                                                </td>
                                                                <td align="center" valign="middle"
                                                                    style="font-weight: 500; font-size: 14px">
                                                                    <div class="d-flex"
                                                                        style="justify-content: space-around;">
                                                                        <v-tooltip bottom>
                                                                            <template v-slot:activator="{ on, attrs }">
                                                                                <v-icon v-on="on" v-bind="attrs"
                                                                                    v-if="row?.slots?.length > 0"
                                                                                    @click="viewSlot(index, row)">mdi-eye</v-icon>
                                                                                <v-icon v-on="on" v-bind="attrs"
                                                                                    v-else>mdi-eye-off</v-icon>
                                                                            </template>
                                                                            <span v-if="row?.slots?.length > 0">View
                                                                                Slots
                                                                            </span>
                                                                            <span v-else>Slot Not Created
                                                                            </span>
                                                                        </v-tooltip>
                                                                        <v-tooltip bottom>
                                                                            <template v-slot:activator="{ on, attrs }">
                                                                                <v-icon v-on="on" v-bind="attrs"
                                                                                    :color="!row?.slots ? 'red' : ''"
                                                                                    @click="addSlot(index, row)">mdi-alarm-plus</v-icon>
                                                                            </template>
                                                                            <span>Create Slots</span>
                                                                        </v-tooltip>
                                                                        <v-tooltip bottom>
                                                                            <template v-slot:activator="{ on, attrs }">
                                                                                <v-icon @click="removeService(index)"
                                                                                    :disabled="index == 0"
                                                                                    color="red">mdi-delete</v-icon>
                                                                            </template>
                                                                            <span>Delete Slots</span>
                                                                        </v-tooltip>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </template>

                                                        <tr v-else>
                                                            <td colspan="6" class="py-4">
                                                                <p
                                                                    class="m-0 row-not-found text-center font-weight-500 font-size-16">
                                                                    <img :src="$assetURL('media/error/empty.png')"
                                                                        class="row-not-found-image" />
                                                                    Uhh... There are no house type at this moment.
                                                                </p>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </div>
                                            </v-row>
                                            <v-col md="12" v-if="
                                                !getServiceType(productCreate.service_type)?.is_house_type_visible
                                            " class="px-0">
                                                <v-row class="mt-1">
                                                    <v-col class="py-0" v-if="!pageLoading">
                                                        <label class="btx-label mt-2 ">Selling Price/Unit Price</label>
                                                    </v-col>
                                                </v-row>
                                                <template>
                                                    <v-row v-for="(row, index) in productCreate.priceList" :key="index"
                                                        class="mb-0">
                                                        <v-col lg="6" class="py-0">

                                                            <v-text-field :min="0"
                                                                oninput="if(this.value < 0) this.value = 0;"
                                                                type="number" solo flat dense :disabled="pageLoading"
                                                                :loading="pageLoading"
                                                                placeholder="Selling Price/Unit Price"
                                                                prepend-inner-icon="mdi-currency-usd"
                                                                v-model="row.selling_cost"
                                                                @keyup="discountPriceChange(index)"
                                                                @keypress="limitDecimal($event, row.selling_cost)"
                                                                v-on:change="discountSelling(index)" :rules="[
                                                                    validateRules.lessThan(
                                                                        row.selling_cost,
                                                                        'Selling Cost',
                                                                        9999
                                                                    ), validateRules.required(row.selling_cost, 'Selling Cost')
                                                                ]" class="mt-0 width-100"
                                                                hide-spin-buttons></v-text-field>
                                                        </v-col>
                                                        <v-col lg="6" class="py-0">

                                                            <v-select :items="priceType"
                                                                v-if="productCreate?.is_recurring != 1"
                                                                v-model="productCreate.charge_type" hide-details
                                                                item-text="name" item-value="value" item-color="cyan"
                                                                placeholder="Price Type" dense filled solo flat :rules="[
                                                                    validateRules.required(productCreate.charge_type, 'Selling Cost')
                                                                ]" style="flex: 1;"></v-select>
                                                        </v-col>
                                                    </v-row>
                                                </template>

                                            </v-col>
                                        </v-card-text>
                                    </v-card>
                                    <v-card flat class="custom-grey-border remove-border-radius">
                                        <v-card-title class="headline grey lighten-4">
                                            <h3 class="font-weight-700 custom-headline color-custom-blue">
                                                Other Details
                                            </h3>
                                            <v-spacer></v-spacer>
                                        </v-card-title>
                                        <v-card-text style="padding-left: 14px !important" class="font-size-16">
                                            <v-layout class="pl-1">
                                                <v-row>
                                                    <v-col lg=6>
                                                        <label
                                                            class="font-weight-700 pl-1 font-size-16">Description</label>
                                                        <editor class="pl-1" hide-details dense filled
                                                            placeholder="Description" solo flat row-height="10"
                                                            auto-grow color="cyan"
                                                            v-model.trim="productCreate.description" :rules="[
                                                                validateRules.minLength(
                                                                    productCreate.description,
                                                                    'description',
                                                                    1
                                                                ),
                                                                validateRules.maxLength(
                                                                    productCreate.description,
                                                                    'description',
                                                                    200
                                                                ),
                                                            ]" v-on:keypress="
                                                                (e) =>
                                                                    manageLimit(
                                                                        e,
                                                                        productCreate.description?.length,
                                                                        199
                                                                    )
                                                            " v-on:paste="(e) => onPaste(e)"></editor>
                                                        <v-col md="12" class="text-right pt-0">{{
                                                            productCreate.description
                                                                ? productCreate.description.length
                                                                : 0
                                                        }}/200</v-col>
                                                    </v-col>
                                                    <v-col lg=6>
                                                        <label class="font-weight-700 pl-1 font-size-16">Terms and
                                                            condition</label>
                                                        <editor class="pl-1" hide-details dense filled
                                                            placeholder="Terms and condition" solo flat row-height="20"
                                                            auto-grow color="cyan"
                                                            v-model.trim="productCreate.terms_and_condition" :rules="[
                                                                validateRules.minLength(
                                                                    productCreate.terms_and_condition,
                                                                    'terms_and_condition',
                                                                    1
                                                                ),
                                                                validateRules.maxLength(
                                                                    productCreate.terms_and_condition,
                                                                    'Name',
                                                                    200
                                                                ),
                                                            ]" v-on:keypress="
                                                                (e) =>
                                                                    manageLimit(
                                                                        e,
                                                                        productCreate.terms_and_condition?.length,
                                                                        199
                                                                    )
                                                            " v-on:paste="(e) => onPaste(e)"></editor>
                                                        <v-col md="12" class="text-right pt-0">{{
                                                            productCreate.terms_and_condition
                                                                ? productCreate.terms_and_condition.length
                                                                : 0
                                                        }}/200</v-col>
                                                    </v-col>
                                                </v-row>
                                            </v-layout>
                                        </v-card-text>
                                    </v-card>
                                    <br />
                                    <v-card flat class="custom-grey-border remove-border-radius mb-0"
                                        v-if="show_skills == 1">
                                        <v-card-title class="headline grey lighten-4">
                                            <h3 class="font-weight-700 custom-headline color-custom-blue">
                                                Skills , Licence & Certs Information
                                            </h3>
                                            <v-spacer></v-spacer>
                                            <v-btn class="white--text mr-2" depressed color="cyan" tile
                                                @click="addCert_dialog = true">
                                                <v-icon left>mdi-plus</v-icon>
                                                Add
                                            </v-btn>
                                        </v-card-title>
                                        <v-card-text style="padding-left: 14px !important">
                                            <div class="pl-2" style="background: whitesmoke">
                                                <v-row>
                                                    <v-col cols="2" lg="2" class="py-0 pl-1">
                                                        <label
                                                            class="font-weight-700 font-size-16 width-100 mt-1">Color</label>
                                                    </v-col>
                                                    <v-col cols="4" lg="4" class="py-0 pl-1">
                                                        <label
                                                            class="font-weight-700 font-size-16 width-100 mt-1">Name</label>
                                                    </v-col>
                                                    <v-col cols="4" lg="4" class="py-0 pl-0">
                                                        <label
                                                            class="font-weight-700 font-size-16 width-100 mt-1">Type</label>
                                                    </v-col>
                                                    <v-col cols="2" lg="2" class="py-0 pl-1"></v-col>
                                                </v-row>
                                            </div>
                                            <template>
                                                <div v-if="productCreate?.skills_carts?.length > 0">
                                                    <v-row v-for="(row, index) in productCreate.skills_carts"
                                                        :key="index" class="mb-0 mx-1 alternate-listing-row-div"
                                                        style="border-bottom: 1px solid #ddd7d7">
                                                        <v-col cols="2" lg="2" class="py-0 my-auto">
                                                            <v-chip small :color="row.color" variant="flat"></v-chip>
                                                        </v-col>
                                                        <v-col cols="4" lg="4" class="py-0 pl-1 my-auto">
                                                            {{ row.name }}
                                                        </v-col>
                                                        <v-col cols="4" lg="4" class="py-0 pl-1 my-auto">
                                                            {{ row.type }}
                                                        </v-col>
                                                        <v-col cols="2" lg="2" class="py-0 my-auto">
                                                            <v-btn icon class="white--text" depressed
                                                                color="red darken-4" @click="removeCert(index, row)"
                                                                min-width="25" max-width="25" width="25">
                                                                <v-icon>mdi-delete</v-icon>
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </div>
                                                <div v-else>
                                                    <p
                                                        class="m-0 row-not-found text-center font-weight-500 font-size-16">
                                                        <img :src="$assetURL('media/error/empty.png')"
                                                            class="row-not-found-image" style="width: 30px" />
                                                        Uhh... There are no skills , licence & certs at the
                                                        moment.
                                                    </p>
                                                </div>
                                            </template>
                                        </v-card-text>
                                    </v-card>
                                    <template v-if="!productId">
                                        <v-row>
                                            <CustomForm :module="'service'" :module-id="productId" />
                                        </v-row>
                                        <br />
                                    </template>
                                </v-container>
                            </perfect-scrollbar>
                        </v-tab-item>
                        <v-tab-item :value="'tab-recurring'">
                            <v-card flat class="custom-grey-border remove-border-radius">
                                <v-card-title class="headline grey lighten-4">
                                    <h3 class="font-weight-700 custom-headline color-custom-blue">
                                        Service Date Off & Team
                                    </h3>
                                </v-card-title>
                                <v-card-text class="p-6 font-size-16">
                                    <v-row v-if="false">
                                        <v-col lg="6" class="py-0">
                                            <label class="mr-2 mb-0"> Special Dates Off </label>

                                            <v-menu ref="menu" v-model="menu" :close-on-content-click="false"
                                                :return-value.sync="productCreate.dates_off"
                                                transition="scale-transition" offset-y min-width="auto">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-select :value="specialDatesOff" :items="specialDatesOff" multiple
                                                        chips small-chips outlined dense
                                                        prepend-inner-icon="mdi-calendar" placeholder="Select dates"
                                                        hide-details readonly
                                                        style="min-width: 250px; border: 1px solid #ccc" v-bind="attrs"
                                                        v-on="on" />
                                                </template>

                                                <v-date-picker v-model="productCreate.dates_off" multiple no-title
                                                    scrollable>
                                                    <v-spacer />
                                                    <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                                                    <v-btn text color="primary"
                                                        @click="$refs.menu.save(productCreate.dates_off)">OK</v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col lg="6" class="py-0">
                                            <label class="mr-2 mb-0 mt-1"> Number of booking per Order </label>
                                            <v-text-field id="price" v-model.trim="productCreate.booking_per_order"
                                                type="number" dense filled placeholder="Number of booking per Order"
                                                solo flat color="cyan" />
                                        </v-col>
                                    </v-row>

                                    <!-- Payment Before Job Switch -->
                                    <!-- <v-col lg="6" class="py-0">
                                            <div class="d-flex align-center">
                                                <label class="mr-3 mb-0 font-weight-600">Payment Before Job</label>
                                                <v-switch v-model.trim="productCreate.payment_before_job" inset
                                                    :true-value="1" :false-value="0" @change="paymentBeforeJobChange()"
                                                    color="cyan" hide-details class="mt-0" />
                                            </div>
                                        </v-col> -->

                                    <!-- Days for Payment (only if switch is on) -->
                                    <v-row>
                                        <v-col lg="6" v-if="false">
                                            <label class="d-block mb-1 font-weight-600 required">Recurring Start Date
                                                limit</label>
                                            <v-text-field id="price" v-model.trim="productCreate.recurring_date_limit"
                                                type="number" dense filled solo flat color="cyan"
                                                placeholder="Enter recurring limit" class="mt-3"
                                                v-on:keypress="isNumber($event)" />
                                        </v-col> <v-col lg="6">
                                            <label class="d-block mb-1 font-weight-600">Maximum No. of Jobs</label>
                                            <v-text-field id="price"
                                                v-model.trim="productCreate.recurring_occurrence_limit" type="number"
                                                dense filled solo flat color="cyan" placeholder="Enter occurrence limit"
                                                :rules="validateRules.required(productCreate.recurring_occurrence_limit, 'Recurring Occurrence Limit')"
                                                class="mt-3" v-on:keypress="isNumber($event)" />
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                            <v-card flat class="custom-grey-border remove-border-radius">
                                <v-card-title class="headline grey lighten-4">
                                    <h3 class="font-weight-700 custom-headline color-custom-blue">
                                        Recurrence Frequency and Charges
                                    </h3>
                                    <v-spacer></v-spacer>
                                </v-card-title>
                                <v-card-text style="padding-left: 14px !important" class="font-size-16">
                                    <v-row class="py-0">
                                        <v-col md="12" class="py-0">
                                            <table class="width-100">
                                                <thead>
                                                    <tr>
                                                        <th>Frequency Type</th>
                                                        <!-- <th>Available Days</th> -->
                                                        <th>Pricing</th>
                                                    </tr>
                                                </thead>
                                                <tbody v-for="(type, index) in productCreate.ServiceAvailablity"
                                                    :key="index">
                                                    <tr>
                                                        <td width="50%">
                                                            <v-checkbox inset color="cyan" :label="type.name" dense
                                                                class="pt-0 mt-2" @change="updateWeekAvailable(type)"
                                                                v-model="type.available" hide-details :false-value="0"
                                                                :true-value="1">
                                                            </v-checkbox>
                                                        </td>
                                                        <!-- <td width="60%"> -->
                                                        <!-- <div class="d-flex flex-wrap align-center">
                                                                <v-checkbox v-for="(week, wIndex) in type.WeekAvailable"
                                                                    :key="wIndex" inset :disabled="!type.available"
                                                                    color="cyan" :label="week.name" dense
                                                                    v-model="week.available" hide-details
                                                                    :false-value="0" :true-value="1"
                                                                    class="ml-1"></v-checkbox>
                                                            </div> -->
                                                        <!-- </td> -->
                                                        <td width="50%" valign="middle" align="center">
                                                            <div class="d-flex flex-column">

                                                                <!-- Regular Price -->
                                                                <div class="d-flex flex-column" style="gap: 4px;">
                                                                    <div class="d-flex" style="gap: 8px;">
                                                                        <v-text-field v-model.trim="type.price"
                                                                            type="number" :disabled="!type.available"
                                                                            dense filled placeholder="Price" solo flat
                                                                            color="cyan" style="flex: 1;"
                                                                            @keypress="limitDecimal($event, type.price)"
                                                                            :rules="[validateRules.lessThan(type.price, 'Free Slot After Payment Cancellation', 9999)]"></v-text-field>

                                                                        <v-select v-if="productId == 0"
                                                                            :items="priceType" v-model="type.price_type"
                                                                            hide-details item-text="name"
                                                                            item-value="value" item-color="cyan"
                                                                            placeholder="Price Type" dense filled solo
                                                                            flat style="flex: 1;"></v-select>

                                                                        <v-select v-if="productId" :items="priceType"
                                                                            v-model="type.priceType" hide-details
                                                                            item-text="name" item-value="value"
                                                                            item-color="cyan" placeholder="Price Type"
                                                                            dense filled solo flat
                                                                            style="flex: 1;"></v-select>
                                                                    </div>
                                                                </div>

                                                                <!-- Twice-a-Week Price -->
                                                                <div v-if="index == 0" class="d-flex flex-column">
                                                                    <label>2x/Week Pricing</label>
                                                                    <div class="d-flex" style="gap: 8px;">
                                                                        <v-text-field
                                                                            v-model.trim="type.twice_weekly_price"
                                                                            type="number" :disabled="!type.available"
                                                                            dense filled placeholder="Price" solo flat
                                                                            color="cyan" style="flex: 1;"
                                                                            @keypress="limitDecimal($event, type.twice_weekly_price)"
                                                                            :rules="[validateRules.lessThan(type.twice_weekly_price, 'Free Slot After Payment Cancellation', 9999)]"></v-text-field>

                                                                        <v-select :items="priceType"
                                                                            v-model="type.twice_weekly_price_type"
                                                                            hide-details item-text="name"
                                                                            item-value="value" item-color="cyan"
                                                                            placeholder="Price Type" dense filled solo
                                                                            flat style="flex: 1;"></v-select>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </td>



                                                    </tr>
                                                </tbody>
                                            </table>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item :value="'tab-addons'">
                            <perfect-scrollbar :options="{ suppressScrollX: true }"
                                class="scroll custom-box-top-inner-shadow service-create-height"
                                style="max-height: 80vh; position: relative">
                                <v-col md="12" class="pb-0">
                                    <AddOns @updateSelectedAddOnList="updateSelectedAddOnList"
                                        :selectedAddOnListProp="productCreateData?.ServicesAddons" />
                                </v-col>
                            </perfect-scrollbar>
                        </v-tab-item>
                        <v-tab-item :value="'tab-slots'">
                            <perfect-scrollbar :options="{ suppressScrollX: true }"
                                class="scroll custom-box-top-inner-shadow service-create-height"
                                style="max-height: 80vh; position: relative">
                                <v-col md="12" class="pb-0">
                                    <Slots @updatedSlots="updatedSlots" @updateSlotType="updateSlotType"
                                        :allSlots="productCreateData?.service_slots" :serviceID="productId"
                                        :details="productCreateData" :same_slots="productCreateData?.slot_type">
                                    </Slots>
                                </v-col>
                            </perfect-scrollbar>
                        </v-tab-item>
                        <v-tab-item :value="'tab-attachments'">
                            <perfect-scrollbar :options="{ suppressScrollX: true }"
                                class="scroll custom-box-top-inner-shadow service-create-height"
                                style="max-height: 80vh; position: relative">
                                <v-col md="12" class="pb-0">
                                    <DocumnetList v-model="productCreate.files" :document-type="docType">
                                    </DocumnetList>
                                </v-col>
                            </perfect-scrollbar>
                        </v-tab-item>
                    </v-tabs-items>
                </v-col>
            </v-row>
        </v-col>
        <ManageService :b-dialog="manageServiceDialog" :service="serviceList"
            v-on:close-dialog="manageServiceDialog = false" v-on:get-service-type="getOptions"></ManageService>
        <CreateSlots @saveUpdatedSlots="saveUpdatedSlots" :addSlot_dialog="addSlotDialog"
            v-on:close-dialog="addSlotDialog = false" :slotDuration="selectedHouseType?.hour"
            :durationTypes="durationTypes" :slot_duration_type="selectedHouseType?.duration_type" />
        <UpdateViewSlots :viewSlots="updateSlots" :slotData="updatedViewSlotData"
            @sentUpdatedSlots="updateViewedDataSlots" v-on:close-dialog="updateSlots = false" />





        <ManageHouse :b-dialog="manageHouseDialog" :house="houseType" v-on:close-dialog="manageHouseDialog = false"
            v-on:get-house-type="getOptions"></ManageHouse>
        <ManageCategory service :c-dialog="manageCategoryDialog" :category="categoryList"
            v-on:close-dialog="manageCategoryDialog = false" v-on:get-product-category="getOptions">
        </ManageCategory>
        <ManageSkill service :c-dialog="manageSkillDialog" :skill="skillCertificateList"
            v-on:close-dialog="manageSkillDialog = false" v-on:get-product-category="getOptions"></ManageSkill>
        <ManageLicense service :c-dialog="manageLicenseDialog" :license="licenseCertificateList"
            v-on:close-dialog="manageLicenseDialog = false" v-on:get-product-category="getOptions"></ManageLicense>
        <AddCertisDialog :product-type="product_type" :related-id="productId" :product-dialog="addCert_dialog"
            v-on:update-values="addSkills" v-on:close="addCert_dialog = false"
            :updated-data="productCreate.skills_carts">
        </AddCertisDialog>
    </v-layout>
</template>

<script>
import AddCertisDialog from "@/view/components/AddCertisDialog.vue";
import Slots from "@/view/components/ServiceSlots.vue";
import AddOns from "@/view/components/AddOns.vue";
import CreateSlots from "@/view/components/CreateSlots.vue";
import UpdateViewSlots from "@/view/components/UpdateViewSlots.vue";
import CustomForm from "@/view/pages/custom-field-v2/CustomForm.vue";
import CommonMixin from "@/core/plugins/common-mixin";
import WarrantyMixin from "@/core/lib//warranty/warranty.mixin";
import ProductMixin from "@/core/plugins/product-mixin";
import ValidationMixin from "@/core/plugins/validation-mixin";
import ManageCategory from "@/view/pages/partials/Manage-Product-Category.vue";
import ManageSkill from "@/view/pages/partials/Manage-Product-Skill.vue";
import ManageLicense from "@/view/pages/partials/Manage-Product-License.vue";
// import ManageServiceUnit from "@/view/pages/partials/Manage-Service-Unit.vue";
//import AttachFile from "@/view/components/AttachFile";
import TagAutoComplete from "@/view/pages/partials/TagAutoCompleteInput";
import DocumnetList from "@/view/pages/DocumnetList";
import TinyMCE from "@/view/pages/partials/TinyMCE.vue";

import {
    QUERY,
    DELETE,
    UPDATE_ERROR,
    CLEAR_ERROR,
} from "@/core/services/store/request.module";
import { map, compact } from "lodash";
// import AllHoliday from "@/view/components/AllHoliday.vue";
import moment from "moment";
import { cloneDeep } from "lodash";
// import DatePicker from "@/view/components/DatePicker";
import FileManagerMixin from "@/core/lib/file-manager/file.manager.mixin";
// import ManageBrand from "@/view/pages/partials/Manage-Product-Brand.vue";
import ManageService from "@/view/pages/partials/Manage-Service-Type.vue";
import ManageHouse from "@/view/pages/partials/Manage-House-Type.vue";
// import TinyMCE from "@/view/pages/partials/TinyMCE.vue";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";

export default {
    name: "product-create",
    mixins: [
        CommonMixin,
        WarrantyMixin,
        ProductMixin,
        ValidationMixin,
        FileManagerMixin,
    ],
    props: {
        productId: {
            type: [Number, String],
            default: null,
        },
        barcodeData: {
            type: String,
            default: null,
        },
        productCreateData: {
            type: Object,
            default: () => {
                return new Object();
            },
        },
        pageLoading: {
            type: Boolean,
            default: false,
        },
    },
    beforeUpdate() {
        this.$store.dispatch(CLEAR_ERROR);
    },
    data() {
        return {
            offDayServiceRules: [
                { name: "Postpone One Day", value: "Postpone_one_day" },
                { name: "Prepone One Day", value: "Prepone_one_day" },
                { name: "No Job On That Day", value: "no_job" },
                { name: "Cancel Job", value: "cancel_job" },
            ],
            durationTypes: [
                { day_of_week: "Minutes", value: "minutes" },
                { day_of_week: "Hours", value: "hours" },
            ],
            docType: 10,
            product_type: null,
            selectedHouseType: {},
            houseSelected: {},
            updateSlots: false,
            updatedViewSlotData: [],
            updateViewSlots: [],
            addSlotDialog: false,
            zoneList: [],
            dialog_key: Number(new Date()),
            // manageBrandDialog: false,
            manageServiceDialog: false,
            // manageHourDialog: false,
            manageHouseDialog: false,
            assetTab: "tab-overview",
            addCert_dialog: false,
            imageLoading: false,
            viewHoliday: false,
            menu: false,
            // pageLoading: false,
            timeoutLimit: 500,
            timeout: null,
            // brandList: new Array(),
            serviceList: new Array(),
            houseType: new Array(),
            hourList: new Array(),
            categoryList: new Array(),
            skillCertificateList: new Array(),
            licenseCertificateList: new Array(),
            manufacturerList: new Array(),
            holidays: new Array(),
            supplierList: new Array(),
            taxList: new Array(),
            taxExemptionList: new Array(),
            // serviceUnitDialog: false,
            unitList: new Array(),
            barcode: null,
            manageCategoryDialog: false,
            manageSkillDialog: false,
            show_skills: 0,
            show_licence: 0,
            manageLicenseDialog: false,
            taxNameList: [],
            warrantyActive: false,
            priceType: [
                { name: "Per Visit", value: "per_visit" },
                { name: "Per Hour", value: "per_hour" },
            ],
            paymentType: [
                { name: "Stripe", value: "stripe" },
                { name: "Paynow", value: "paynow" },
                { name: "Bank", value: "bank" },
            ],
            tabs: [
                {
                    title: "Overview",
                    icon: "mdi-format-list-bulleted",
                    key: "overview",
                    permission: "customer",
                    status: true,
                },
                {
                    title: "Add Ons",
                    icon: "mdi-plus",
                    key: "addons",
                    permission: "customer",
                    status: true,
                },
                {
                    title: "Recurring Services",
                    icon: "mdi-repeat",
                    key: "recurring",
                    permission: "customer",
                    status: false,
                },
                {
                    title: "Dates & Slots",
                    icon: "mdi-clock",
                    key: "slots",
                    permission: "customer",
                    status: true,
                },
                {
                    title: "Attachments",
                    icon: "mdi-file",
                    key: "attachments",
                    permission: "customer",
                    status: true,
                },
            ],

            charge_type_list: [
                { type: "%", value: 2 },
                { type: "$", value: 1 },
            ],
            productCreate: {
                name: null,
                product_prefix: null,
                product_prefix_no: null,
                tags: null,
                specification: null,
                no_penalty_cancel_days: false,
                reference: null,
                sku: null,
                upc: null,
                ean: null,
                isbn: null,
                part_number: null,
                service_type: null,
                house_type: null,
                house_size: null,
                hsn_code: null,
                description: null,
                directory: null,
                supplier: null,
                // brand: null,
                barcode: null,
                manufacturer: null,
                category: null,
                license: [],
                skill: [],
                chargeList: [],
                slotData: [{}],
                unit: "unit",
                tax: null,
                tax_exemption: null,
                accounting: "none",
                int_service_number: null,
                ref_number: null,
                product_type: "service",
                purchase_cost: null,
                selectedAddOnList: [],
                selling_cost: null,
                commission_rate: null,
                length: null,
                width: null,
                height: null,
                weight: null,
                firstTime: true,
                taxable: false,
                sellable: true,
                confirmed: false,
                track_batch: false,
                manage_stock: true,
                reorder_level: null,
                is_recurring: null,
                charge_type: null,
                is_service_form: false,
                initial_stock: null,
                charges: null,
                cost: null,
                images: [],
                service_image: null,
                product_images: [],
                product_atach: null,
                tax_rate: null,
                tax_name: null,
                custom_tax: 1,
                skills_carts: [],
                serviceSelected: [{
                    house_type: null,
                    size: 0,
                    price: 0,
                }],
                notify:
                {
                    admin: null,
                    sales: null,
                    customer: null,
                },
                ServiceAvailablity: [
                    {
                        service_id: 1,
                        available: false,
                        name: "Weekly",
                        WeekAvailable: [
                            { weekID: 1, name: "Sunday", available: true },
                            { weekID: 1, name: "Monday", available: true },
                            { weekID: 1, name: "Tuesday", available: true },
                            { weekID: 1, name: "Wednesday", available: true },
                            { weekID: 1, name: "Thursday", available: true },
                            { weekID: 1, name: "Friday", available: true },
                            { weekID: 1, name: "Saturday", available: true },
                        ],
                        price: "",
                        priceType: "Per Visit",
                    },
                    {
                        service_id: 2,
                        available: false,
                        name: "Bi Weekly",
                        WeekAvailable: [
                            { weekID: 1, name: "Sunday", available: true },
                            { weekID: 1, name: "Monday", available: true },
                            { weekID: 1, name: "Tuesday", available: true },
                            { weekID: 1, name: "Wednesday", available: true },
                            { weekID: 1, name: "Thursday", available: true },
                            { weekID: 1, name: "Friday", available: true },
                            { weekID: 1, name: "Saturday", available: true },
                        ],
                        price: "",
                        priceType: "Per Visit",
                    },

                    {
                        service_id: 4,
                        available: false,
                        name: "Monthly",
                        value: "monthlyOptions",
                        WeekAvailable: [
                            { weekID: 1, name: "Sunday", available: true },
                            { weekID: 1, name: "Monday", available: true },
                            { weekID: 1, name: "Tuesday", available: true },
                            { weekID: 1, name: "Wednesday", available: true },
                            { weekID: 1, name: "Thursday", available: true },
                            { weekID: 1, name: "Friday", available: true },
                            { weekID: 1, name: "Saturday", available: true },
                        ],
                        price: "",
                        priceType: "per_visit",
                    },
                    {
                        service_id: 5,
                        available: false,
                        name: "Quarterly",
                        value: "quarterlyOptions",
                        WeekAvailable: [
                            { weekID: 1, name: "Sunday", available: true },
                            { weekID: 1, name: "Monday", available: true },
                            { weekID: 1, name: "Tuesday", available: true },
                            { weekID: 1, name: "Wednesday", available: true },
                            { weekID: 1, name: "Thursday", available: true },
                            { weekID: 1, name: "Friday", available: true },
                            { weekID: 1, name: "Saturday", available: true },
                        ],
                        price: "",
                        priceType: "per_visit",
                    },
                    /* {
                        service_id: 5,
                        available: false,
                        name: "Bi Month",
                        WeekAvailable: [
                            { weekID: 1, name: "Monday", available: false },
                            { weekID: 1, name: "Tuesday", available: false },
                            { weekID: 1, name: "Wednesday", available: false },
                            { weekID: 1, name: "Thursday", available: false },
                            { weekID: 1, name: "Friday", available: false },
                            { weekID: 1, name: "Saturday", available: false },
                        ],
                        price: "",
                        priceType: "per_visit",
                    }, */
                ],

                priceList: [
                    {
                        id: null,
                        unit_price: 0,
                        selling_price: 0,
                        discount_price: 0,
                        start_date: moment().format("YYYY-MM-DD"),
                        end_date: null,
                    },
                ],
                warranty: [
                    {
                        id: null,
                        value: null,
                        field: null,
                    },
                ],
                files: [
                    {
                        file: null,
                        name: null,
                        remark: null,
                        suffix: null,
                        tags: null,
                        search: null,
                        start_date: null,
                        end_date: null,
                        reminder_date: null,
                    },
                ],
            },
            customTaxList: [
                {
                    text: "Yes",
                    value: 1,
                },
                {
                    text: "No",
                    value: 0,
                },
            ],
            fieldDescriptions: [
                {
                    field: "product_type",
                    title: "Product Type",
                    description:
                        "Select if this item is a physical good or a service you're offering.",
                    footer: "Note",
                    footer_content:
                        "Once you include this items in a transaction, you cannot change its type.",
                },
            ],
            asset_image: null,
        };
    },
    components: {
        AddCertisDialog,
        UpdateViewSlots,
        // AllHoliday,
        Slots,
        CreateSlots,
        AddOns,
        ManageCategory,
        ManageService,
        ManageHouse,
        TagAutoComplete,
        ManageSkill,
        ManageLicense,
        CustomForm,
        DocumnetList,
        editor: TinyMCE,
    },
    watch: {
        barcodeData(param) {
            this.barcode = param;
            // console.log(this.barcode)
        },

        productCreateData: {
            deep: true,
            //immediate: true,
            handler(param) {
                this.productCreate = param;
                this.productCreate.is_recurring = param.is_recurring;
                this.checkRecurringStatus(this.productCreate?.is_recurring);
                this.checkHouseTypeStatus();

                if (this.lodash.isObject(this.productCreate.unit)) {
                    this.productCreate.unit = this.productCreate.unit
                        ? this.productCreate.unit
                        : "unit";
                    this.productCreate.barcode = this.barcode;

                    const files = map(this.productCreate.files, (row) => {
                        return { ...row };
                    });
                    if (files.length) {
                        this.productCreate.attachment = files;
                    }
                }

                if (param && this.lodash.isEmpty(param.warranty)) {
                    this.warrantyActive = true;
                    this.productCreate.warranty.push({
                        id: null,
                        value: null,
                        field: null,
                    });
                }
                if (this.$route && this.$route.query && this.$route.query.duplicate) {
                    this.productCreate.barcode = param.barcode
                        ? param.barcode
                        : this.barcode;
                }

                this.$nextTick(() => {
                    if (param.warranty && param.warranty.length) {
                        const item = compact(map(param.warranty, "id"));
                        if (item && item.length) {
                            this.warrantyActive = true;
                        }
                    }
                });
            },
        },
        productCreate: {
            deep: true,
            handler() {
                const _this = this;
                clearTimeout(_this.timeout);
                _this.timeout = setTimeout(function () {
                    let obj = _this.unitList.find(
                        (o) => o.text === _this.productCreate.unit
                    );
                    if (!obj) {
                        _this.productCreate.unit = "unit";
                    }

                    _this.$emit("saveProduct", _this.productCreate);
                }, _this.timeoutLimit);

                // this.productCreate.barcode = this.barcode;
            },
        },
        "productCreate.product_type"() {
            this.getOptions();
        },
    },
    methods: {
        updateViewedDataSlots(param) {
            this.productCreate.serviceSelected[this.houseSelected].slots = param;
            this.updateSlots = false;
            this.updatedViewSlotData = null;
        },
        saveUpdatedSlots(param) {
            this.productCreate.serviceSelected[this.houseSelected].slots = param;
            this.addSlotDialog = false;
        },
        addSlot(index, row) {
            this.addSlotDialog = true;
            this.houseSelected = index;
            this.selectedHouseType = row;
        },
        viewSlot(index, data) {
            this.updateSlots = true;
            this.houseSelected = index;
            this.updatedViewSlotData = data?.slots;

        },
        removeService(index) {
            this.productCreate.serviceSelected.splice(index, 1);
        },
        addService() {
            this.productCreate.serviceSelected.push({});
        },
        updateSelectedAddOnList(param) {
            if (param) {
                this.productCreate.selectedAddOnList = param;
            }
        },
        cancelValueUpdated(param) {
            if (param == 0) {
                this.productCreate.chargeList = [];
                this.productCreate.zone = null;
                this.productCreate.payment_mode = null;
                this.productCreate.no_penalty_cancel_days = 0;
            }
        },
        updateWeekAvailable(type) {
            if (!type.available) {
                let weekIndex = this.productCreate.ServiceAvailablity.findIndex((row) => row.service_id == type.service_id);
                this.productCreate.ServiceAvailablity[weekIndex].WeekAvailable.map((row) => {
                    row.available = false;
                });
                this.productCreate.ServiceAvailablity[weekIndex].price = '';
            }
        },
        getHolidays() {
            const _this = this;
            _this.$store
                .dispatch(QUERY, {
                    url: "holiday",
                    data: { year: new Date().getFullYear().toString() },
                })
                .then((response) => {
                    this.holidays = response.data;
                })
                .catch((error) => {
                    _this.logError(error);
                });
        },
        checkRecurringStatus(data) {
            let recurringIndex = this.tabs.findIndex((row) => row.key == "recurring");
            this.tabs[recurringIndex].status = data;
        },
        checkHouseTypeStatus() {
            let isHouseTypeVisible = this.getServiceType(this.productCreate.service_type)?.is_house_type_visible;
            let recurringIndex = this.tabs.findIndex((row) => row.key == "slots");
            this.tabs[recurringIndex].status = !isHouseTypeVisible;

        },
        updatedSlots(param) {
            this.productCreate.slotsData = param;
        },
        updateSlotType(param) {
            this.productCreate.slot_type = param;
        },
        addSkills(data) {
            let selectedCarts = data;
            this.productCreate.skills_carts = selectedCarts;
            /*  selectedCarts.map((row) => {
               this.productCreate.skills_carts.push(row);
                 }
             ); */
        },
        addType() {
            this.productCreate.chargeList.push({});
        },
        deleteCharges(index) {
            if (this.productCreate.chargeList.length > 1) {
                this.productCreate.chargeList.splice(index, 1);
            }
        },
        removePrice(index) {
            if (index >= 1) {
                this.productCreate.priceList[index - 1].end_date = null;
            }
            this.productCreate.priceList.splice(index, 1);
        },
        getServiceType(type) {
            return this.serviceList.find((value) => value.type === type);
        },
        discountPriceChange(index) {
            if (
                this.productCreate.priceList[index].discount_price >
                this.productCreate.priceList[index].selling_cost
            ) {
                this.productCreate.priceList[index].discount_price =
                    this.productCreate.priceList[index].selling_cost;
            }
        },
        discountSelling(index) {
            if (
                this.productCreate.priceList[index].selling_cost <
                this.productCreate.priceList[index].discount_price
            ) {
                this.productCreate.priceList[index].selling_cost =
                    this.productCreate.priceList[index].discount_price;
            }
        },
        removeCert(index) {
            this.productCreate.skills_carts.splice(index, 1);
        },
        updateProfileImage(param) {
            const _this = this;
            _this.imageLoading = true;
            _this
                .uploadAttachment(param, _this.productId)
                .then((response) => {
                    let data = _this.lodash.head(response);
                    _this.asset_image =
                        data && data.file && data.file.url ? data.file.url : null;
                    /*  _this.productCreate.product_atach =
                      data && data.file && data.file.url ? data.file.url : null; */
                    _this.productCreate.images = [data.id];
                })
                .catch((error) => {
                    _this.logError(error);
                })
                .finally(() => {
                    _this.imageLoading = false;
                });
        },
        selectImage() {
            this.$refs["uploadImage"].$refs["input"].click();
        },
        onPaste(e) {
            let coppied = e.clipboardData.getData("Text");
            let preVal = this.productCreate.description;
            let finalval = String(preVal) + String(coppied);
            if (Number(finalval.length) > 199) {
                let trimValue = finalval.substring(0, 200);
                this.productCreate.description = trimValue;
                e.preventDefault();
            }
        },
        onPasteSize(e) {
            let coppied = e.clipboardData.getData("Text");
            let preVal = this.productCreate.house_size;
            let finalval = String(preVal) + String(coppied);
            if (Number(finalval.length) > 19) {
                let trimValue = finalval.substring(0, 20);
                this.productCreate.house_size = trimValue;
                e.preventDefault();
            }
        },
        onPasteHour(e) {
            let coppied = e.clipboardData.getData("Text");
            let preVal = this.productCreate.hours;
            let finalval = String(preVal) + String(coppied);
            if (Number(finalval.length) > 19) {
                let trimValue = finalval.substring(0, 20);
                this.productCreate.hours = trimValue;
                e.preventDefault();
            }
        },
        manageLimit(e, data_length, length) {
            if (length && data_length > length) {
                e.preventDefault();
            }
        },
        // BrandData() {
        //   this.manageBrandDialog = true;
        //   this.getOptions();
        // },
        ServiceData() {
            this.manageServiceDialog = true;
            this.getOptions();
        },
        onServiceTypeChange() {
            this.productCreate.hours = null;
            this.productCreate.house_size = null;
            this.productCreate.house_type = null;

            this.productCreate.serviceSelected = [{
                'house_type': null,
                'size': null,
                'hours': null,
                'price': null,
                'slots': null
            }]
            this.checkHouseTypeStatus();

        },
        houseData() {
            this.manageHouseDialog = true;
            this.getOptions();
        },
        // UomData() {
        //   this.serviceUnitDialog = true;
        //   this.getOptions();
        // },
        CategoryData() {
            this.manageCategoryDialog = true;
            this.getOptions();
        },
        SkillData() {
            this.manageSkillDialog = true;
            //this.getOptions();
        },
        LicenseData() {
            this.manageLicenseDialog = true;
            this.getOptions();
        },
        updateImages(param) {
            this.productCreate.images = param;
        },
        pushWarranty() {
            this.productCreate.warranty.push({
                id: null,
                value: null,
                field: null,
            });
        },
        removeWarranty(index, id) {
            const _this = this;
            if (id && id > 0) {
                _this.$store
                    .dispatch(DELETE, {
                        url: "product/" + _this.productId + "/entity",
                        data: {
                            type: 1,
                            entities: [id],
                        },
                    })
                    .then(() => {
                        _this.productCreate.warranty.splice(index, 1);
                    })
                    .catch((error) => {
                        _this.logError(error);
                    });
            } else {
                _this.productCreate.warranty.splice(index, 1);
            }
        },
        paymentBeforeJobChange() {
            if (this.productCreate.payment_before_job) {
                this.productCreate.payment_before_job_days = 0;
            }
        },
        getOptions() {
            const _this = this;
            _this.$store
                .dispatch(QUERY, {
                    url: "product/options",
                    data: { product_type: _this.productCreate.product_type },
                })
                .then((response) => {
                    if (_this.lodash.isEmpty(response.data) === false) {
                        this.show_skills = response.data.skills_cert_lecn_show;
                        /*   this.show_licence = response.data.show_licence.value; */
                    }
                    // if (
                    //   _this.lodash.isEmpty(response.data) === false &&
                    //   response.data.brand
                    // ) {
                    //   _this.brandList = response.data.brand;
                    // }
                    if (
                        _this.lodash.isEmpty(response.data) === false &&
                        response.data.serviceType
                    ) {
                        _this.serviceList = response.data.serviceType;
                    }
                    if (
                        _this.lodash.isEmpty(response.data) === false &&
                        response.data.houseType
                    ) {
                        _this.houseType = response.data.houseType;
                    }
                    if (
                        _this.lodash.isEmpty(response.data) === false &&
                        response.data.zonelist
                    ) {
                        _this.zoneList = response.data.zonelist;
                    }
                    if (
                        _this.lodash.isEmpty(response.data) === false &&
                        response.data.hourType
                    ) {
                        _this.hourList = response.data.hourType;
                    }
                    if (
                        _this.lodash.isEmpty(response.data) === false &&
                        response.data.category
                    ) {
                        _this.categoryList = response.data.category;
                    }
                    if (
                        _this.lodash.isEmpty(response.data) === false &&
                        response.data.manufacturer
                    ) {
                        _this.manufacturerList = response.data.manufacturer;
                    }
                    if (
                        _this.lodash.isEmpty(response.data) === false &&
                        response.data.tax_names
                    ) {
                        _this.taxNameList = response.data.tax_names;
                    }
                    if (
                        _this.lodash.isEmpty(response.data) === false &&
                        response.data.licenseCertificate
                    ) {
                        _this.licenseCertificateList = response.data.licenseCertificate;
                    }

                    if (
                        _this.lodash.isEmpty(response.data) === false &&
                        response.data.skillCertificate
                    ) {
                        _this.skillCertificateList = response.data.skillCertificate;
                    }

                    if (
                        _this.lodash.isEmpty(response.data) === false &&
                        response.data.supplier
                    ) {
                        _this.supplierList = response.data.supplier;
                    }
                    if (
                        _this.lodash.isEmpty(response.data) === false &&
                        response.data.tax
                    ) {
                        _this.taxList = response.data.tax;
                        if (!_this.productCreate.tax) {
                            let index = _this.lodash.findIndex(
                                response.data.tax,
                                function (tax) {
                                    return tax.default;
                                }
                            );
                            if (index >= 0) {
                                _this.productCreate.tax = _this.taxList[index].id;
                            }
                        }
                    }
                    if (
                        _this.lodash.isEmpty(response.data) === false &&
                        response.data.taxExemption
                    ) {
                        _this.taxExemptionList = response.data.taxExemption;
                        if (!_this.productCreate.tax_exemption) {
                            let index = _this.lodash.findIndex(
                                response.data.taxExemption,
                                function (taxExemption) {
                                    return taxExemption.default;
                                }
                            );
                            if (index >= 0) {
                                _this.productCreate.tax_exemption =
                                    _this.taxExemptionList[index].id;
                            }
                        }
                    }
                    if (
                        _this.lodash.isEmpty(response.data) === false &&
                        response.data.unit
                    ) {
                        _this.unitList = response.data.unit;
                        //UOM when deleted
                        let obj = _this.unitList.find(
                            (o) => o.text === _this.productCreate.unit
                        );
                        if (!obj) {
                            _this.productCreate.unit = null;
                        }
                    }
                    if (
                        !_this.productId &&
                        _this.lodash.isEmpty(response.data) === false &&
                        response.data.barcode
                    ) {
                        _this.barcode = response.data.barcode;
                        _this.productCreate.barcode = response.data.barcode;
                    }


                    /* if (_this.lodash.isEmpty(response.data.barcode_setting) === false) {
                      _this.barcodeSetting = response.data.barcode_setting;
                      _this.productCreate.description = _this.barcodeSetting.description;
                    } */
                })
                .catch((error) => {
                    _this.$store.dispatch(UPDATE_ERROR, error);
                });
        },
        validateTeamRange() {
            const min = Number(this.productCreate.min_team);
            const max = Number(this.productCreate.max_team);

            if (min && max && min > max) {
                this.productCreate.max_team = null;
                ErrorEventBus.$emit(
                    "update:error",
                    InitializeError("Minimum worker cannot exceed maximum worker.")
                );
                return false;
            }

            if (min && max && max < min) {
                this.productCreate.min_team = null;
                ErrorEventBus.$emit(
                    "update:error",
                    InitializeError("Maximum worker cannot be less than minimum worker.")
                );
                return false;
            }
        },
    },
    mounted() {
        this.getOptions();
    },
    computed: {
        specialDatesOff() {
            if (this.productCreate?.dates_off?.length > 0) {
                return this.productCreate.dates_off.map(date => moment(date).format('DD/MM/YYYY'));
            }
            else {
                return null;

            }
        },
        isStartDateDisable: () => {
            return function (index) {
                if (this.productCreate.priceList.length == index + 1) {
                    return false;
                }
                return true;
            };
        },
        end_min_date: () => {
            return function (date, index) {
                let _priceList = cloneDeep(this.productCreate.priceList);
                if (index > 0) {
                    const min_end_date = _priceList[index - 1].start_date;
                    this.productCreate.priceList[index - 1].end_date = date;
                    return min_end_date;
                }
                return moment().format("YYYY-MM-DD");
            };
        },
        getProfileImage() {
            return this.asset_image
                ? this.asset_image
                : this.productCreate?.service_image?.file?.url;
        },
        /* getProfileImage() {
          return this.productCreate.product_atach && !this.productId
            ? this.productCreate.product_atach
            : this.productCreateData?.product_images?.file?.url;
        }, */
    },
};
</script>
<style scoped>
/* tabs css  */

.custom-tab-transparent.v-tabs--fixed-tabs>.v-tabs-bar .v-tab.v-tab--active {
    background-color: #00bcd4 !important;
    color: #fff !important;
    overflow: hidden;
}

.custom-tab-transparent.v-tabs--fixed-tabs>.v-tabs-bar .v-tab.v-tab--active .grey--text.text--darken-4 {
    color: #fff !important;
    caret-color: #fff !important;
}

.custom-tab-transparent.v-tabs .v-tab {
    background: #00bcd429;
    width: 15%;
    clip-path: polygon(0% 0%,
            calc(100% - 30px) 0%,
            100% 50%,
            calc(100% - 50px) 150%,
            0% 100%,
            calc(0% + 20px) 50%);
}

.custom-tab-transparent.v-tabs .v-tab:first-child {
    clip-path: polygon(0% 0%,
            calc(100% - 30px) 0%,
            100% 50%,
            calc(100% - 50px) 150%,
            0% 100%,
            calc(0% + 0px) 50%);
}

.custom-tab-transparent.v-tabs .v-tab.v-tab:last-child {
    clip-path: polygon(0% 0%,
            calc(100% + -0px) 0%,
            100% 100%,
            calc(100% - 40px) 150%,
            0% 100%,
            calc(0% + 20px) 50%);
}

.skeleton-circle {
    height: 200px;
    width: 200px;
    border-radius: 50%;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    /* mimic image shadow */
    border: 1px solid #ccc;
    /* mimic image border */
}

.custom-suffix-field .v-input__append-inner {
    background-color: #e0f7fa;
    border-left: 2px solid #00bcd4;
    padding-left: 8px;
    color: #007c91;
    font-weight: 600;
    border-radius: 0 6px 6px 0;
}
</style>